import styled, { css } from 'styled-components';

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  font-size: 14px;
`;

export const Frame = styled.div`
  line-height: 0;
  background: #ffffff;

  ${({ $bordered }) =>
    $bordered &&
    css`
      padding: 8px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
    `}
`;
